import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hasLogin: false,
    user: {
      username: undefined,
      authority: undefined,
      nickname: undefined,
      isAdmin: false,
      isAppAdmin: false,
      isUser: false
    },
    image: {
      deleteIcon: require("@/assets/删除.png"),
      modifyIcon: require("@/assets/编辑.png")
    },
  },
  mutations: {
    login(state, payload) {
      state.hasLogin = true
      state.user.username = payload.username
      state.user.authorities = payload.authorities
      state.user.nickname = payload.realName || payload.mobileNumber || payload.email || payload.username

      payload.authorities.forEach(e => {
        switch (e.authorityType) {
          case "ROLE_SUPER_ADMIN":
            state.user.isAdmin = true;
            break;
          case "ROLE_APP_ADMIN":
            state.user.isAppAdmin = true;
            break;
          case "ROLE_USER":
            state.user.isUser = true;
            break;
        }
      })
    },
    logout(state) {
      state.hasLogin = false
    }
  },
  actions: {},
  modules: {}
})
